export const patientActions = {
  storePtObject,
  selectLevel,
  selectContamPeriod,
  selectIncubationPeriod,
  selectInfPeriodPrior,
  selectInfPeriodAfter,
  selectTestTimeBuffer,
  constrainOverlap,
  storeContactList,
  storeTree,
  storeTreeSnp2NameMap,
  storeSnpDistance,
  storeGraph,
  storeViewedObj,
  storeLayers,
  constrainTree,
  graphInfoToggled,
  storeEdgeWidthParam,
  storeEdgeColourParam,
  constrainGraph,
  highlightPhylos,
  heatmapSelect,
  constrainByOverlap,
  graphLoadingStart,
  graphLoadingEnd,
  graphProgressSet,
  showFutureSequences,
  constraintLoadingStart,
  constraintLoadingEnd,
  constraintLoadingReset,
  setOverlapView,
};

function storePtObjectSucceeded(micro_id, pt_object) {
  return {
    type: "STORE_PT_OBJ_SUCCEEDED",
    payload: {
      micro_id: micro_id,
      pt_object: pt_object,
    },
  };
}

function storePtObject(micro_id, ptObj) {
  return (dispatch) => {
    dispatch(storePtObjectSucceeded(micro_id, ptObj));
  };
}

function selectLevelSucceeded(level) {
  return {
    type: "SELECT_LEVEL_SUCCEEDED",
    payload: {
      level: level,
    },
  };
}

function selectLevel(level) {
  return (dispatch) => {
    dispatch(selectLevelSucceeded(level));
  };
}

function selectContamPeriodSucceeded(contam_period) {
  return {
    type: "SELECT_CONTAM_PERIOD_SUCCEEDED",
    payload: {
      contam_period: contam_period,
    },
  };
}

function selectContamPeriod(level) {
  return (dispatch) => {
    dispatch(selectContamPeriodSucceeded(level));
  };
}

function selectIncubationPeriodSucceeded(incubation) {
  //console.log("select incubation suceeded", incubation);
  return {
    type: "SELECT_INCUBATION_PERIOD_SUCCEEDED",
    payload: {
      incubation: incubation,
    },
  };
}

function selectIncubationPeriod(incubation) {
  return (dispatch) => {
    dispatch(selectIncubationPeriodSucceeded(incubation));
  };
}

function selectInfPeriodPriorSucceeded(inf_prior) {
  return {
    type: "SELECT_INF_PRIOR_SUCCEEDED",
    payload: {
      inf_period_prior: inf_prior,
    },
  };
}

function selectInfPeriodPrior(inf_prior) {
  return (dispatch) => {
    dispatch(selectInfPeriodPriorSucceeded(inf_prior));
  };
}

function selectInfPeriodAfterSucceeded(inf_after) {
  return {
    type: "SELECT_INF_AFTER_SUCCEEDED",
    payload: {
      inf_period_after: inf_after,
    },
  };
}

function selectInfPeriodAfter(inf_after) {
  return (dispatch) => {
    dispatch(selectInfPeriodAfterSucceeded(inf_after));
  };
}

function selectTestTimeBufferSucceeded(test_time_buffer) {
  return {
    type: "SELECT_TTB_SUCCEEDED",
    payload: {
      test_time_buffer: test_time_buffer,
    },
  };
}

function selectTestTimeBuffer(inf_after) {
  return (dispatch) => {
    dispatch(selectTestTimeBufferSucceeded(inf_after));
  };
}

function constrainOverlapSucceeded(leaves) {
  return {
    type: "CONSTRAIN_OVERLAP_SUCCEEDED",
    payload: { leaves: leaves },
  };
}

function constrainOverlap(leaves) {
  return (dispatch) => {
    dispatch(constrainOverlapSucceeded(leaves));
  };
}

function storeViewedObjSucceeded(micro_id, name) {
  return {
    type: "STORE_VIEWED_OBJ_SUCCEEDED",
    payload: {
      micro_id: micro_id,
      name: name,
    },
  };
}

function storeViewedObj(micro_id, name) {
  return (dispatch) => {
    dispatch(storeViewedObjSucceeded(micro_id, name));
  };
}

function storeContactListSucceeded(contact_list) {
  return {
    type: "STORE_CONTACT_LIST_SUCCEEDED",
    payload: {
      contact_list: contact_list,
    },
  };
}

function storeContactList(contact_list) {
  return (dispatch) => {
    dispatch(storeContactListSucceeded(contact_list));
  };
}

function storeTreeSucceeded(tree, matrix, name_map) {
  return {
    type: "STORE_TREE_SUCCEEDED",
    payload: {
      tree: tree,
      matrix: matrix,
      name_map: name_map,
    },
  };
}

function storeTreeSnp2NameMap(name_map) {
  return {
    type: 'STORE_TREE_SNP2_NAMEMAP_SUCCEEDED',
    payload: {
      name_map_snp2: name_map,
    }
  };
}

function storeTree(tree, matrix, name_map) {
  return (dispatch) => {
    dispatch(storeTreeSucceeded(tree, matrix, name_map));
  };
}

function storeSnpDistanceSucceeded(snps) {
  return {
    type: "STORE_SNP_DIST_SUCCEEDED",
    payload: {
      snp_dist: snps,
    },
  };
}

function storeSnpDistance(snps) {
  return (dispatch) => {
    dispatch(storeSnpDistanceSucceeded(snps));
  };
}

function storeGraphSucceeded(nodes, edges, key) {
  return {
    type: "STORE_GRAPH_SUCCEEDED",
    payload: {
      nodes: nodes,
      edges: edges,
      key: key,
    },
  };
}

function storeGraph(nodes, edges, key) {
  return (dispatch) => {
    dispatch(storeGraphSucceeded(nodes, edges, key));
  };
}

function storeLayersSucceeded(layers) {
  return {
    type: "STORE_LAYERS_SUCCEEDED",
    payload: { layers: layers },
  };
}

function storeLayers(layers) {
  return (dispatch) => {
    dispatch(storeLayersSucceeded(layers));
  };
}

function constrainTreeSucceeded(srces) {
  return {
    type: "CONSTRAIN_TREE_SUCCEEDED",
    payload: { srces: srces },
  };
}

function constrainTree(srces) {
  return (dispatch) => {
    dispatch(constrainTreeSucceeded(srces));
  };
}

function graphInfoToggleSucceeded(toggled) {
  return {
    type: "TOGGLE_GRAPH_INFO",
    payload: { toggled },
  };
}

function graphInfoToggled(toggled) {
  return (dispatch) => {
    dispatch(graphInfoToggleSucceeded(toggled));
  };
}

function graphLoadingStart() {
  return (dispatch) => {
    dispatch({ type: "GRAPH_LOADING_START" });
  };
}

function graphLoadingEnd() {
  return (dispatch) => {
    dispatch({ type: "GRAPH_LOADING_END" });
  };
}

function graphProgressSet(progress) {
  return (dispatch) => {
    dispatch({ type: "GRAPH_PROGRESS_SET", payload: progress });
  };
}

function storeEdgeWidthParamSucceded(param) {
  return {
    type: "EDGE_WIDTH_PARAM",
    payload: { param },
  };
}

function storeEdgeWidthParam(param) {
  return (dispatch) => {
    dispatch(storeEdgeWidthParamSucceded(param));
  };
}

function storeEdgeColourParamSucceded(param) {
  return {
    type: "EDGE_COLOUR_PARAM",
    payload: { param },
  };
}

function storeEdgeColourParam(param) {
  return (dispatch) => {
    dispatch(storeEdgeColourParamSucceded(param));
  };
}

function constrainGraphSucceeded(leaves, bool) {
  return {
    type: "CONSTRAIN_GRAPH_SUCCEEDED",
    payload: { leaves: leaves, pruneForPhylos: bool },
  };
}

function constrainGraph(leaves, bool) {
  return (dispatch) => {
    dispatch(constrainGraphSucceeded(leaves, bool));
  };
}

function highlightPhylosSucceeded(leaves, bool) {
  return {
    type: "HIGHLIGHT_PHYLOS_SUCCEEDED",
    payload: { leaves: leaves, highlightPhylos: bool },
  };
}

function highlightPhylos(leaves, bool) {
  return (dispatch) => {
    dispatch(highlightPhylosSucceeded(leaves, bool));
  };
}

function heatmapSelectSucceeded(bool) {
  return {
    type: "HEATMAP_SELECT_SUCCEEDED",
    payload: bool,
  };
}

function heatmapSelect(bool) {
  return (dispatch) => {
    dispatch(heatmapSelectSucceeded(bool));
  };
}

function setOverlapView(view) {
  return (dispatch) => {
    dispatch({
      type: "SET_OVERLAP_VIEW",
      payload: { view },
    });
  };
}

function constrainByOverlapSucceeded(bool) {
  return {
    type: "CONSTRAIN_BY_OVERLAP",
    payload: bool,
  };
}

function constrainByOverlap(bool) {
  return (dispatch) => {
    dispatch(constrainByOverlapSucceeded(bool));
  };
}

function constraintLoadingStart() {
  return (dispatch) => {
    dispatch({ type: "CONSTRAINT_LOADING_START" });
  };
}

function constraintLoadingEnd() {
  return (dispatch) => {
    dispatch({ type: "CONSTRAINT_LOADING_END" });
  };
}

function constraintLoadingReset() {
  return (dispatch) => {
    dispatch({ type: "CONSTRAINT_LOADING_RESET" });
  };
}

function showFutureSequencesSuceeded(bool) {
  return {
    type: "SHOW_FUTURE_SEQUENCES_SUCEEDED",
    payload: bool,
  };
}

function showFutureSequences(bool) {
  return (dispatch) => {
    dispatch(showFutureSequencesSuceeded(bool));
  };
}
